import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Spinner from "react-bootstrap/Spinner";
import { useAlert } from "react-alert";
import { positions, Provider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import axios from "axios";
import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";

const Subscription = () => {
  const alert = useAlert();
  const theme = useTheme();

  const [userId, setUserId] = useState("");
  const [clientId, setClientId] = useState("");
  const [org, setOrg] = useState("");
  const [center, setCenter] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [reportsSubscribed, setReportsSubscribed] = useState("");
  const [subscriptionStatus, setSubscriptionStatus] = useState("");
  const [copySubscriptionStatus, setCopySubscriptionStatus] = useState("");

  const [mailID, setMailId] = useState("");
  const [dashboardAccess, setDashboardAccess] = useState("");
  const [portalAccess, setPortalAccess] = useState("");
  const [smartReportAccess, setsmartReportAccess] = useState("");
  const [bodySummary, setBodySummary] = useState("");
  const [reportSummary, setReportSummary] = useState("");
  const [addtionalTestRec, setaddtionalTestRec] = useState("");
  const [reportType, setReportType] = useState("");
  const [npsScore, setNpsScore] = useState("");

  const [copyDashboardAccess, setCopyDashboardAccess] = useState("");
  const [copyportalAccess, setCopyPortalAccess] = useState("");
  const [copysmartReportAccess, setCopysmartReportAccess] = useState("");
  const [copybodySummary, setCopyBodySummary] = useState("");
  const [copyreportSummary, setCopyReportSummary] = useState("");
  const [copyaddtionalTestRec, setCopyaddtionalTestRec] = useState("");
  const [copyreportType, setCopyReportType] = useState("");
  const [displaySubscription, setDisplaySubscription] = useState("");
  const [zohobooksData, setZohobooksData] = useState({});
  const [lamdbaDetails, setLambdaDetails] = useState({ name: "", link: "" });
  const [integrationType, setIntegrationType] = useState("");
  const [serviceType, setServiceType] = useState("");
  const [copyServiceType, setCopyServiceType] = useState("");
  const [numberOfTickets, setNumberOfTickets] = useState("");
  const [planType, setPlanType] = useState("");
  const [copyPlanType, setCopyPlanType] = useState("");
  const [clientType, setClientType] = useState("");
  const [copyClientType, setCopyClientType] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [copyCustomerName, setCopyCustomerName] = useState("");

  // const [selectedUserId, setSelectedUserId] = useState("")
  const [fetchOrgStatus, setFetchOrgStatus] = useState(true);
  const [recordOfClientData, setRecordOfClientData] = useState([]);
  const [enableSpinner, setEnableSpinner] = useState(false);
  const [errorWhileFetchingDetails, setErrorWhileFetchingDetails] =
    useState("");
  const [holdOrgData, setHoldOrgData] = useState("");
  const [copyStartDate, setCopyStartDate] = useState("");
  const [copyEndDate, setCopyEndDate] = useState("");
  const [correctJsonFormat, setCorrectJsonFormat] = useState("");

  const [rerenderReact, setRerenderReact] = useState(false);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [password, setPassword] = useState("");
  const [prevStartDate, setPrevStartDate] = useState("");
  const [prevEndDate, setPrevEndDate] = useState("");
  const [copyPrevStartDate, setCopyPrevStartDate] = useState("");
  const [copyPrevEndDate, setCopyPrevEndDate] = useState("");
  const [saveOldSubscription, setSaveOldSubscription] = useState(false);
  const [loadingClientLookup, setLoadingClientLookup] = useState(true);

  useEffect(() => {
    let getLoginDetails = localStorage.getItem("loginDetails");

    if (getLoginDetails) {
      let theData = JSON.parse(localStorage.getItem("loginDetails"));
      console.log("getting:", theData);
      if (theData.role === "admin") {
        fetchOrgForUpdation();
      } else {
        window.location.replace("/");
      }
    }
  }, []);

  const submitHandler = (e) => {
    e.preventDefault();

    // handling date format (attaching current time with the date)
    // var currentTime = new Date();
    // var currentOffset = currentTime.getTimezoneOffset();

    // var ISTOffset = 330;   // IST offset UTC +5:30
    // var ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000);

    // var hoursIST = ISTTime.getHours()
    // var minutesIST = ISTTime.getMinutes()

    // let theLength = hoursIST.toString().length
    // let lastString = "59.000"

    // if (theLength === 1) {
    //     hoursIST = "0" + hoursIST
    // }

    // let format = `${hoursIST}:${minutesIST}:${lastString}`

    // console.log(format)

    let objJson = {
      org: org,
      center: center,
      userId: userId,
      clientId: clientId,
      startDate:
        startDate === copyStartDate ? startDate : `${startDate} 00:00:00.000`,
      endDate: endDate === copyEndDate ? endDate : `${endDate} 23:59:59.000`,
      reportsSubscribed: reportsSubscribed,
      subscriptionStatus: subscriptionStatus,
      npsScore: npsScore === "" ? null : Number(npsScore),
      reportSubscription: {
        reportType: reportType,
        addOns: {
          bodySummary: bodySummary,
          reportSummary: reportSummary,
          additionalTestRecommendation: addtionalTestRec,
        },
      },
      notifications: {
        mailIds: mailID.includes(",") ? mailID.split(",") : [mailID],
      },
      accessTo: {
        dashBoard: dashboardAccess,
        portal: portalAccess,
        smartReport: smartReportAccess,
      },
      subscription: displaySubscription,
      reportAddons: selectedAddons,
      zohobooks: zohobooksData,
      lamdbaDetails: lamdbaDetails,
      integrationType: integrationType,
      serviceType: serviceType || "",
      numberOfTickets:
        numberOfTickets === "" || numberOfTickets === null
          ? ""
          : parseInt(numberOfTickets, 10),
      planType: planType || "",
      clientType: clientType || "",
      customerName: customerName || "",
      savePreviousDates: saveOldSubscription,
      prevSubscriptionDetails: [
        {
          startDate:
            prevStartDate === copyPrevEndDate
              ? prevStartDate
              : prevStartDate
              ? `${prevStartDate} 00:00:00.000`
              : "",
          endDate:
            prevEndDate === copyPrevEndDate
              ? prevEndDate
              : prevEndDate
              ? `${prevEndDate} 23:59:59.000`
              : "",
        },
      ],
    };

    console.log("Sending:\n", objJson);
    console.log("Customer Name being sent:", customerName);
    setCorrectJsonFormat(objJson);
  };

  var selectedUserId = "";

  const fetchOrgForUpdation = async () => {
    setLoadingClientLookup(true);
    const clientDataStatus = localStorage.getItem("loginDetails");
    const clientChoosen = JSON.parse(localStorage.getItem("choosenClient"));

    if (clientDataStatus) {
      let clientsData = JSON.parse(clientDataStatus).clientData;
      setRecordOfClientData(clientsData);

      console.log("clientsData here:\n", clientsData, clientChoosen);
      // Find the selected client once and fetch details; avoid flicker by setting status once
      let found = false;
      for (let i = 0; i < clientsData.length; i++) {
        let eachObj = clientsData[i];
        if (
          eachObj.org === clientChoosen.org &&
          eachObj.center === clientChoosen.center
        ) {
          console.log("required obj:", eachObj);
          selectedUserId = eachObj.userId;
          await handleSubscriptionDetails();
          found = true;
          break;
        }
      }
      await setFetchOrgStatus(found);
    }
    setLoadingClientLookup(false);
  };

  const handleSubscriptionDetails = async () => {
    setEnableSpinner(true);
    let detailsEndpoint = `https://rnxsohimg1.execute-api.ap-south-1.amazonaws.com/Production/subscription/status?userId=${selectedUserId}`;

    var config = {
      method: "GET",
      url: detailsEndpoint,
      // url: "",
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      console.log("fetching ====>", detailsEndpoint);
      const axiosData = await axios(config);
      console.log('API Response data:', axiosData.data.data);
      console.log('Customer Name from API:', axiosData.data.data.customerName);
      await setHoldOrgData(axiosData.data.data);

      // updating states values
      await setUserId(axiosData.data.data.userId);
      await setClientId(axiosData.data.data.clientId);
      await setOrg(axiosData.data.data.org);
      await setCenter(axiosData.data.data.center);
      await setStartDate(axiosData.data.data.startDate);
      await setEndDate(axiosData.data.data.endDate);
      await setReportsSubscribed(axiosData.data.data.reportsSubscribed);
      await setSubscriptionStatus(axiosData.data.data.subscriptionStatus);
      await setCopySubscriptionStatus(axiosData.data.data.subscriptionStatus);
      await setPassword(axiosData.data.data.password);

      await setCopyStartDate(axiosData.data.data.startDate);
      await setCopyEndDate(axiosData.data.data.endDate);

      await setMailId(axiosData.data.data.notifications.mailIds.join(","));
      await setDashboardAccess(axiosData.data.data.accessTo.dashBoard);
      await setCopyDashboardAccess(axiosData.data.data.accessTo.dashBoard);
      await setPortalAccess(axiosData.data.data.accessTo.portal);
      await setCopyPortalAccess(axiosData.data.data.accessTo.portal);
      await setsmartReportAccess(axiosData.data.data.accessTo.smartReport);
      await setCopysmartReportAccess(axiosData.data.data.accessTo.smartReport);
      await setDisplaySubscription(axiosData.data.data.subscription);

      if (axiosData.data.data.reportAddons) {
        await setSelectedAddons(axiosData.data.data.reportAddons);
      }

      if (axiosData.data.data.hasOwnProperty("zohobooks")) {
        setZohobooksData(axiosData.data.data.zohobooks);
      }

      if (axiosData.data.data.lamdbaDetails) {
        setLambdaDetails(axiosData.data.data.lamdbaDetails);
      }
      if (axiosData.data.data.integrationType) {
        setIntegrationType(axiosData.data.data.integrationType);
      }

      if (axiosData.data.data.serviceType) {
        const srv = axiosData.data.data.serviceType;
        const normalized = typeof srv === "string" ? srv.toString().trim().toLowerCase() : "";
        const display = normalized === "portal" ? "Portal" : normalized === "api" ? "API" : (srv || "");
        setServiceType(display);
        setCopyServiceType(display);
      } else {
        setServiceType("");
        setCopyServiceType("");
      }

      if (Object.prototype.hasOwnProperty.call(axiosData.data.data, "numberOfTickets")) {
        const nt = axiosData.data.data.numberOfTickets;
        setNumberOfTickets(nt === null || nt === undefined ? "" : String(nt));
      } else {
        setNumberOfTickets("");
      }

      if (axiosData.data.data.hasOwnProperty("planType")) {
        const pt = axiosData.data.data.planType;
        setPlanType(pt === null || pt === undefined ? "" : String(pt));
        setCopyPlanType(pt === null || pt === undefined ? "" : String(pt));
      } else {
        setPlanType("");
        setCopyPlanType("");
      }

      if (axiosData.data.data.hasOwnProperty("clientType")) {
        const ct = axiosData.data.data.clientType;
        setClientType(ct === null || ct === undefined ? "" : String(ct));
        setCopyClientType(ct === null || ct === undefined ? "" : String(ct));
      } else {
        setClientType("");
        setCopyClientType("");
      }

      if (axiosData.data.data.hasOwnProperty("customerName")) {
        const cn = axiosData.data.data.customerName;
        setCustomerName(cn === null || cn === undefined ? "" : String(cn));
        setCopyCustomerName(cn === null || cn === undefined ? "" : String(cn));
      } else {
        setCustomerName("");
        setCopyCustomerName("");
      }

      if (axiosData?.data?.data?.subscriptionHistory?.length) {
        setPrevStartDate(
          axiosData.data.data.subscriptionHistory[0]?.startDate || ""
        );
        setPrevEndDate(
          axiosData.data.data.subscriptionHistory[0]?.endDate || ""
        );
        setCopyPrevStartDate(
          axiosData.data.data.subscriptionHistory[0]?.startDate || ""
        );
        setCopyPrevEndDate(
          axiosData.data.data.subscriptionHistory[0]?.endDate || ""
        );
      }

      if (axiosData.data.data.hasOwnProperty("npsScore")) {
        await setNpsScore(
          axiosData.data.data.npsScore === -1 || axiosData.data.data.npsScore === null
            ? ""
            : axiosData.data.data.npsScore
        );
      }
      if (axiosData.data.data.hasOwnProperty("reportSubscription")) {
        await setReportType(axiosData.data.data.reportSubscription.reportType);
        await setCopyReportType(
          axiosData.data.data.reportSubscription.reportType
        );
        if (axiosData.data.data.reportSubscription.hasOwnProperty("addOns")) {
          await setReportSummary(
            axiosData.data.data.reportSubscription.addOns.reportSummary
          );
          await setCopyReportSummary(
            axiosData.data.data.reportSubscription.addOns.reportSummary
          );
          await setBodySummary(
            axiosData.data.data.reportSubscription.addOns.bodySummary
          );
          await setCopyBodySummary(
            axiosData.data.data.reportSubscription.addOns.bodySummary
          );

          await setaddtionalTestRec(
            axiosData.data.data.reportSubscription.addOns
              .additionalTestRecommendation
          );
          await setCopyaddtionalTestRec(
            axiosData.data.data.reportSubscription.addOns
              .additionalTestRecommendation
          );
        }
      }

      setEnableSpinner(false);
      setFetchOrgStatus(true);
    } catch (error) {
      setEnableSpinner(false);
      setErrorWhileFetchingDetails(`Error: ${error.message}`);
      setTimeout(() => {
        setErrorWhileFetchingDetails("");
      }, 3000);
      console.log(
        "Error while fetching subscription details:\n",
        error.message
      );
    }
  };

  const submitSubscriptionData = async () => {
    var config = {
      method: "POST",
      // url: "",
      url: "https://rnxsohimg1.execute-api.ap-south-1.amazonaws.com/Production/subscription/update",
      headers: {
        "Content-Type": "application/json",
      },
      data: correctJsonFormat,
    };

    try {
      const axiosData = await axios(config);
      console.log("subscription data updated:", axiosData);
      console.log("Update response data:", axiosData.data);
      setCorrectJsonFormat("");
      fetchOrgForUpdation();
      // alert.success('Data Updated');
      window.alert("Data Updated");
      try {
        window.dispatchEvent(new CustomEvent("subscription-updated"));
      } catch (_) {}
      // window.location.reload();
      // setRerenderReact(!rerenderReact)
      //
      // Fire-and-forget email notification if status changed to LIVE or ON HOLD
      try {
        const prevStatus = (copySubscriptionStatus || "").toString().trim().toLowerCase();
        const nextStatus = (subscriptionStatus || "").toString().trim().toLowerCase();
        const shouldNotify = prevStatus !== nextStatus && (nextStatus === "live" || nextStatus === "on hold");
        if (shouldNotify) {
          const recipients = (mailID || "")
            .split(",")
            .map((e) => e.trim())
            .filter(Boolean);
          // Optional CC support: from API data if present, or a local override list in localStorage (key: notificationCC)
          let ccEmails = [];
          try {
            const ccFromData = (holdOrgData && holdOrgData.notifications && Array.isArray(holdOrgData.notifications.ccMailIds)) ? holdOrgData.notifications.ccMailIds : [];
            const ccFromLocal = (localStorage.getItem("notificationCC") || "")
              .split(",")
              .map((e) => e.trim())
              .filter(Boolean);
            ccEmails = Array.from(new Set([...(ccFromData || []), ...ccFromLocal]));
          } catch (_) {}
          if (recipients.length) {
            const subject = nextStatus === "live" ? "Your subscription is now LIVE" : "Your subscription is now ON HOLD";
            const prettyNext = nextStatus.toUpperCase();
            const prettyPrev = (prevStatus || "-").toUpperCase();
            const body = `Hello,\n\nYour subscription status for ${org || ""} / ${center || ""} has been updated from ${prettyPrev} to ${prettyNext}.\n\nIf you have any questions, please contact support.\n\nRegards,\nNiroggyan`;

            const maildata = {
              fromEmail: ["reports@niroggyan.com"],
              toEmail: recipients,
              ...(ccEmails && ccEmails.length ? { ccEmail: ccEmails } : {}),
              subject: subject,
              emailBody: body,
            };
            const mailApi = "https://917sfoy1xc.execute-api.ap-south-1.amazonaws.com/Testing/notifications/email";
            const options = {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(maildata),
            };
            fetch(mailApi, options).catch(() => {});
          }
        }
      } catch (_) {}
    } catch (error) {
      alert.error("Subscription Failed");
      console.log("Error while updating subscription data:\n", error.message);
    } finally {
      setSaveOldSubscription(false);
    }
  };

  // Select Org Logic
  const userIdSelectionJSX = () => {
    return (
      <>
        {/* <div className='mb-3' style={{ display: errorWhileFetchingDetails === "" ? "none" : "", border: "1px solid #ff4d4d", padding: "12px", borderRadius: "6px" }}>
                    <span style={{ color: "#ff4d4d" }}>{errorWhileFetchingDetails}</span>
                </div>
                <label className='mb-2'><b>{"Select User Id"}</b></label>
                <Form.Select aria-label="Default select example" onChange={(e) => setSelectedUserId(e.target.value)}>
                    <option value="">-- --</option>
                    {recordOfClientData.length > 0 ? recordOfClientData.map((each, idx) => (
                        <option value={each.userId} key={idx}>{each.userId}</option>
                    )) : ""}
                </Form.Select>

                {enableSpinner ?
                    <>
                        <button
                            className='btn btn-info btn-sm my-3'
                        >
                            <Spinner size="sm" animation="border" role="status" /> {"Loading..."}
                        </button>
                    </>
                    :
                    <button
                        onClick={handleSubscriptionDetails}
                        className='btn btn-info btn-sm my-3'
                        disabled={selectedUserId === ""}
                    >
                        {"Get Subscription Details"}
                    </button>
                } */}

        <h3>{"Client Not Registered with dashboard!"}</h3>
      </>
    );
  };

  const reportTypeMap = {
    compact: "Compact",
    dynamic: "Personal",
    advanced: "Total",
  };

  const addonElements = [
    "Cover Page",
    "Body Summary",
    "Report Summary",
    "Test Recommendation",
    "Trend Report",
    "Viz App",
    "Smart Video Report",
    "Marketing Page",
    "Corporate Dashboard",
  ];

  const ITEM_HEIGHT = 42;
  const ITEM_PADDING_TOP = 8;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedAddons(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  console.log("selectedAddons", selectedAddons);

  // Form Logic
  const returnFormJsx = () => {
    if (userId === "" && clientId === "") {
      return <>{"Client Not Registered with dashboard!"}</>;
    } else {
      return (
        <>
          <Form onSubmit={submitHandler}>
            <div className="inputFields">
              <InputGroup className="mb-3">
                <InputGroup.Text id="inputGroup-sizing-default">
                  <b>{"userId"}</b>
                </InputGroup.Text>
                <Form.Control
                  disabled
                  type="text"
                  defaultValue={userId}
                  onChange={(e) => setUserId(e.target.value)}
                  placeholder="userId"
                />
              </InputGroup>

              <InputGroup className="mb-3">
                <InputGroup.Text id="inputGroup-sizing-default">
                  <b>{"clientId"}</b>
                </InputGroup.Text>
                <Form.Control
                  disabled
                  type="text"
                  defaultValue={clientId}
                  onChange={(e) => setClientId(e.target.value)}
                  placeholder="clientId"
                />
              </InputGroup>
            </div>
            <div className="inputFields">
              <InputGroup className="mb-3">
                <InputGroup.Text id="inputGroup-sizing-default">
                  <b>{"org"}</b>
                </InputGroup.Text>
                <Form.Control
                  disabled
                  type="text"
                  defaultValue={org}
                  onChange={(e) => setOrg(e.target.value)}
                  placeholder="org"
                />
              </InputGroup>

              <InputGroup className="mb-3">
                <InputGroup.Text id="inputGroup-sizing-default">
                  <b>{"center"}</b>
                </InputGroup.Text>
                <Form.Control
                  disabled
                  type="text"
                  defaultValue={center}
                  onChange={(e) => setCenter(e.target.value)}
                  placeholder="center"
                />
              </InputGroup>

              <InputGroup className="mb-3">
                <InputGroup.Text id="inputGroup-sizing-default">
                  <b>{"Password"}</b>
                </InputGroup.Text>
                <Form.Control
                  disabled
                  type="text"
                  defaultValue={password}
                  placeholder="password"
                />
              </InputGroup>

              <InputGroup className="mb-3">
                <InputGroup.Text id="inputGroup-sizing-default">
                  <b>{"Customer Name"}</b>
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  value={customerName}
                  onChange={(e) => setCustomerName(e.target.value)}
                  placeholder="Enter Customer Name"
                  aria-label="Customer Name"
                />
              </InputGroup>
            </div>
            <div className="inputFields">
              <InputGroup className="mb-3">
                <InputGroup.Text
                  style={{ fontWeight: "bold" }}
                  id="basic-addon16"
                >
                  {`DashBoard Access ${
                    copyDashboardAccess !== ""
                      ? copyDashboardAccess === true
                        ? "(Yes)"
                        : "(No)"
                      : ""
                  }`}
                </InputGroup.Text>
                <Form.Select
                  aria-label="DashBoard Access"
                  onChange={(e) => {
                    if (e.target.value === "true") {
                      setDashboardAccess(true);
                    } else {
                      setDashboardAccess(false);
                    }
                  }}
                >
                  {copyDashboardAccess === "" && (
                    <option value={""} disabled selected>
                      {"Select Option"}
                    </option>
                  )}
                  <option value={true} selected={dashboardAccess === true}>
                    {"YES"}
                  </option>
                  <option value={false} selected={dashboardAccess === false}>
                    {"No"}
                  </option>
                </Form.Select>
            </InputGroup>

            {/* NPS score in its own block for spacing */}
            <div className="inputFields">
              <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon-nps" style={{ fontWeight: "bold" }}>
                  NPS Score
                </InputGroup.Text>
                <Form.Control
                  type="number"
                  inputMode="numeric"
                  placeholder="Enter NPS score"
                  value={npsScore}
                  onChange={(e) => setNpsScore(e.target.value)}
                  min={-100}
                  max={100}
                />
              </InputGroup>
            </div>
              <InputGroup className="mb-3">
                <InputGroup.Text
                  style={{ fontWeight: "bold" }}
                  id="basic-addon17"
                >
                  {`Portal Access  ${
                    copyportalAccess !== ""
                      ? copyportalAccess === true
                        ? "(Yes)"
                        : "(No)"
                      : ""
                  }`}
                </InputGroup.Text>
                <Form.Select
                  aria-label="Portal Access"
                  onChange={(e) => {
                    if (e.target.value === "true") {
                      setPortalAccess(true);
                    } else {
                      setPortalAccess(false);
                    }
                  }}
                >
                  {copyportalAccess === "" && (
                    <option value={""} disabled selected>
                      {"Select Option"}
                    </option>
                  )}
                  <option value={true} selected={portalAccess === true}>
                    {"YES"}
                  </option>
                  <option value={false} selected={portalAccess === false}>
                    {"No"}
                  </option>
                </Form.Select>
              </InputGroup>
              <InputGroup className="mb-3">
                <InputGroup.Text
                  style={{ fontWeight: "bold" }}
                  id="basic-addon18"
                >
                  {`Smart Report Access ${
                    copysmartReportAccess !== ""
                      ? copysmartReportAccess === true
                        ? "(Yes)"
                        : "(No)"
                      : ""
                  }`}
                </InputGroup.Text>
                <Form.Select
                  aria-label="Smart Report Access"
                  onChange={(e) => {
                    if (e.target.value === "true") {
                      setsmartReportAccess(true);
                    } else {
                      setsmartReportAccess(false);
                    }
                  }}
                >
                  {copysmartReportAccess === "" && (
                    <option value={""} disabled selected>
                      {"Select Option"}
                    </option>
                  )}
                  <option value={true} selected={smartReportAccess === true}>
                    {"YES"}
                  </option>
                  <option value={false} selected={smartReportAccess === false}>
                    {"No"}
                  </option>
                </Form.Select>
              </InputGroup>
            </div>
            <div className="inputFields">
              <InputGroup className="mb-3">
                <InputGroup.Text
                  style={{ fontWeight: "bold" }}
                  id="basic-addon19"
                >
                  {`Body Summary ${
                    copybodySummary !== ""
                      ? copybodySummary === true
                        ? "(Yes)"
                        : "(No)"
                      : "(NA)"
                  }`}
                </InputGroup.Text>
                <Form.Select
                  aria-label="Body Summary"
                  onChange={(e) => {
                    if (e.target.value === "true") {
                      setBodySummary(true);
                    } else {
                      setBodySummary(false);
                    }
                  }}
                >
                  {copybodySummary === "" && (
                    <option value={""} disabled selected>
                      {"Select Option"}
                    </option>
                  )}
                  <option value={true} selected={bodySummary === true}>
                    {"YES"}
                  </option>
                  <option value={false} selected={bodySummary === false}>
                    {"No"}
                  </option>
                </Form.Select>
              </InputGroup>

              <InputGroup className="mb-3">
                <InputGroup.Text
                  style={{ fontWeight: "bold" }}
                  id="basic-addon20"
                >
                  {`Report Summary ${
                    copyreportSummary !== ""
                      ? copyreportSummary === true
                        ? "(Yes)"
                        : "(No)"
                      : "(NA)"
                  }`}
                </InputGroup.Text>
                <Form.Select
                  aria-label="Report Summary"
                  onChange={(e) => {
                    if (e.target.value === "true") {
                      setReportSummary(true);
                    } else {
                      setReportSummary(false);
                    }
                  }}
                >
                  {copyreportSummary === "" && (
                    <option value={""} disabled selected>
                      {"Select Option"}
                    </option>
                  )}
                  <option value={true} selected={reportSummary === true}>
                    {"YES"}
                  </option>
                  <option value={false} selected={reportSummary === false}>
                    {"No"}
                  </option>
                </Form.Select>
              </InputGroup>
              <InputGroup className="mb-3">
                <InputGroup.Text
                  style={{ fontWeight: "bold" }}
                  id="basic-addon21"
                >
                  {`Test Recommendation ${
                    copyaddtionalTestRec !== ""
                      ? copyaddtionalTestRec === true
                        ? "(Yes)"
                        : "(No)"
                      : "(NA)"
                  }`}
                </InputGroup.Text>
                <Form.Select
                  id="basic-addon21"
                  aria-label="basic-addon21"
                  onChange={(e) => {
                    console.log(e.target.value, Boolean(e.target.value));
                    if (e.target.value === "true") {
                      setaddtionalTestRec(true);
                    } else {
                      setaddtionalTestRec(false);
                    }
                  }}
                >
                  {copyaddtionalTestRec === "" && (
                    <option value={""} disabled selected>
                      {"Select Option"}
                    </option>
                  )}
                  <option value={true} selected={addtionalTestRec === true}>
                    {"YES"}
                  </option>
                  <option value={false} selected={addtionalTestRec === false}>
                    {"No"}
                  </option>
                </Form.Select>
              </InputGroup>
            </div>
            <div className="inputFields">
              <InputGroup className="mb-3">
                <InputGroup.Text
                  style={{ fontWeight: "bold" }}
                  id="basic-addon22"
                  title={"Enter Multiple mail ID's seperated by comma"}
                >
                  {"Notification Mail Id"}
                </InputGroup.Text>
                <Form.Control
                  // required
                  onChange={(e) => {
                    setMailId(e.target.value);
                  }}
                  defaultValue={mailID}
                  placeholder="Mail ID"
                  aria-label="Mail ID"
                  aria-describedby="basic-addon22"
                />
              </InputGroup>
              <InputGroup className="mb-3">
                <InputGroup.Text
                  style={{ fontWeight: "bold" }}
                  id="basic-addon22"
                >
                  {`Report Type ${
                    copyreportType !== ""
                      ? `(${reportTypeMap[copyreportType]})`
                      : "(NA)"
                  }`}
                </InputGroup.Text>
                <Form.Select
                  aria-label="Report Type"
                  onChange={(e) => {
                    setReportType(e.target.value);
                  }}
                >
                  <option value={""} disabled selected>
                    {"Select Report Type"}
                  </option>
                  <option value={"dynamic"} selected={reportType === "dynamic"}>
                    {"Personal"}
                  </option>
                  <option
                    value={"advanced"}
                    selected={reportType === "advanced"}
                  >
                    {"Total"}
                  </option>
                  <option value={"compact"} selected={reportType === "compact"}>
                    {"Compact"}
                  </option>
                </Form.Select>
              </InputGroup>
            </div>
            {/* add ons  */}
            <div>
              <Stack direction="row" alignItems="center" mb={2}>
                {/* <Typography sx={{border:""}}>Add Ons</Typography> */}
                <InputGroup.Text
                  style={{ fontWeight: "bold", alignSelf: "stretch" }}
                  id="basic-addon22"
                  title={"Enter Multiple mail ID's seperated by comma"}
                >
                  Report Add-ons
                </InputGroup.Text>
                <FormControl
                  size="small"
                  sx={{ flexGrow: "1", minWidth: "300px" }}
                >
                  {/* <InputLabel id="demo-multiple-chip-label"></InputLabel> */}
                  <Select
                    labelId="demo-multiple-chip-label"
                    id="demo-multiple-chip"
                    multiple
                    value={selectedAddons}
                    onChange={handleChange}
                    input={<OutlinedInput id="select-multiple-chip" label="" />}
                    renderValue={(selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((value) => (
                          <Chip key={value} label={value} />
                        ))}
                      </Box>
                    )}
                    MenuProps={MenuProps}
                  >
                    {addonElements.map((name) => (
                      <MenuItem
                        key={name}
                        value={name}
                        style={getStyles(name, selectedAddons, theme)}
                      >
                        {name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Stack>
            </div>
            {/* add ons  */}
            <InputGroup className="mb-3">
              <InputGroup.Text style={{ fontWeight: "bold" }} id="basic-addon7">
                {"Subscription - Display"}
              </InputGroup.Text>
              <Form.Control
                required
                defaultValue={displaySubscription}
                onChange={(e) => {
                  setDisplaySubscription(e.target.value);
                }}
                placeholder="compact/dynamic/advanced"
                aria-label="subscription"
                aria-describedby="basic-addon7"
              />
            </InputGroup>
            {/* previous start & end dates */}
            <InputGroup className="mb-3 custom-Date-mobile">
              <InputGroup.Text id="inputGroup-sizing-default">
                <b>{"Previous Subscription StartDate"}</b>{" "}
                <span className="mx-1"></span>{" "}
                {copyPrevStartDate && (
                  <span>
                    <b>{"("}</b>
                    {copyPrevStartDate} <b>{")"}</b>
                  </span>
                )}
              </InputGroup.Text>
              <Form.Control
                type="date"
                defaultValue={prevStartDate}
                onChange={(e) => setPrevStartDate(e.target.value)}
                placeholder="prev startDate"
                className="calander-mobile"
              />
            </InputGroup>
            <InputGroup className="mb-3 custom-Date-mobile">
              <InputGroup.Text id="inputGroup-sizing-default">
                <b>{"previous Subscription EndDate"}</b>{" "}
                <span className="mx-1"></span>{" "}
                {copyPrevEndDate && (
                  <span>
                    <b>{"("}</b>
                    {copyPrevEndDate} <b>{")"}</b>
                  </span>
                )}
              </InputGroup.Text>
              <Form.Control
                type="date"
                defaultValue={prevEndDate}
                onChange={(e) => setPrevEndDate(e.target.value)}
                placeholder="prev endDate"
                className="calander-mobile"
              />
            </InputGroup>
            {/* previous start & end dates */}

            <InputGroup className="mb-3 custom-Date-mobile">
              <InputGroup.Text id="inputGroup-sizing-default">
                <b>{"startDate"}</b> <span className="mx-1"></span> <b>{"("}</b>
                {copyStartDate} <b>{")"}</b>
              </InputGroup.Text>
              <Form.Control
                type="date"
                defaultValue={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                placeholder="startDate"
                className="calander-mobile"
              />
            </InputGroup>
            <InputGroup className="mb-3 custom-Date-mobile">
              <InputGroup.Text id="inputGroup-sizing-default">
                <b>{"endDate"}</b> <span className="mx-1"></span> <b>{"("}</b>
                {copyEndDate} <b>{")"}</b>
              </InputGroup.Text>
              <Form.Control
                type="date"
                defaultValue={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                placeholder="endDate"
                className="calander-mobile"
              />
            </InputGroup>
            {/* flag to store previous dates */}
            <div className="mb-3">
              <InputGroup className="custom-Date-mobile">
                <InputGroup.Text id="inputGroup-sizing-default">
                  <b>Save previous subscription dates?</b>
                </InputGroup.Text>
                <div className="d-flex align-items-center ms-2">
                  <Form.Check
                    inline
                    label="Yes"
                    name="preservePrevious"
                    type="radio"
                    id="preserve-yes"
                    onChange={() => setSaveOldSubscription(true)}
                    checked={saveOldSubscription === true}
                  />
                  <Form.Check
                    inline
                    label="No"
                    name="preservePrevious"
                    type="radio"
                    id="preserve-no"
                    onChange={() => setSaveOldSubscription(false)}
                    checked={saveOldSubscription === false}
                  />
                </div>
              </InputGroup>
              <p
                style={{ textAlign: "left", fontSize: "13px", marginBottom: 0 }}
              >
                (Choose "Yes" only if the current subscription is over and you
                want to save its dates before setting the next one.)
              </p>
            </div>

            <div className="inputFields">
              <InputGroup className="mb-3">
                <InputGroup.Text
                  style={{ fontWeight: "bold" }}
                  id="basic-addon7"
                >
                  {"Zohobooks - CustomerId"}
                </InputGroup.Text>
                <Form.Control
                  defaultValue={zohobooksData?.customerId || ""}
                  onChange={(e) => {
                    setZohobooksData({
                      ...zohobooksData,
                      customerId: e.target.value,
                    });
                  }}
                  placeholder="Customer ID"
                  aria-label="subscription"
                  aria-describedby="basic-addon7"
                />
              </InputGroup>
              <InputGroup className="mb-3">
                <InputGroup.Text
                  style={{ fontWeight: "bold" }}
                  id="basic-addon7"
                >
                  {"Zohobooks - Due Threshold"}
                </InputGroup.Text>
                <Form.Control
                  defaultValue={zohobooksData?.dueThreshold || ""}
                  onChange={(e) => {
                    setZohobooksData({
                      ...zohobooksData,
                      dueThreshold: e.target.value,
                    });
                  }}
                  placeholder="Due Threshold"
                  aria-label="subscription"
                  aria-describedby="basic-addon7"
                />
              </InputGroup>
            </div>
            <InputGroup className="mb-3">
              <InputGroup.Text id="inputGroup-sizing-default">
                <b>{"reportsSubscribed"}</b>
              </InputGroup.Text>
              <Form.Control
                type="number"
                defaultValue={reportsSubscribed}
                onChange={(e) => setReportsSubscribed(e.target.value)}
                placeholder="reportsSubscribed"
              />
            </InputGroup>
            {/* lambda name & link  */}
            <div className="inputFields">
              <InputGroup className="mb-3">
                <InputGroup.Text id="inputGroup-sizing-default">
                  <b>{"Lambda Name"}</b>
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  defaultValue={lamdbaDetails.name ? lamdbaDetails.name : ""}
                  onChange={(e) =>
                    setLambdaDetails((prevState) => ({
                      ...prevState,
                      name: e.target.value,
                    }))
                  }
                  placeholder="Enter Lambda Name"
                />
              </InputGroup>

              <InputGroup className="mb-3">
                <InputGroup.Text id="inputGroup-sizing-default">
                  <b>{"Lambda Link"}</b>
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  defaultValue={lamdbaDetails.link ? lamdbaDetails.link : ""}
                  onChange={(e) =>
                    setLambdaDetails((prevState) => ({
                      ...prevState,
                      link: e.target.value,
                    }))
                  }
                  placeholder="Enter Lambda Link"
                />
              </InputGroup>
            </div>
            {/* lambda name & link  */}

            {/* integration type */}
            <div>
              <InputGroup className="mb-3">
                <InputGroup.Text
                  style={{ fontWeight: "bold" }}
                  id="basic-addon22"
                >
                  Integration Type
                </InputGroup.Text>
                <Form.Select
                  aria-label="Report Type"
                  onChange={(e) => {
                    setIntegrationType(e.target.value);
                  }}
                >
                  {integrationType === "" && (
                    <option value={""} disabled selected>
                      {"Select Option"}
                    </option>
                  )}

                  <option
                    value={"modelA"}
                    selected={integrationType === "modelA"}
                  >
                    Model A
                  </option>
                  <option
                    value={"modelB"}
                    selected={integrationType === "modelB"}
                  >
                    Model B
                  </option>
                </Form.Select>
              </InputGroup>
            </div>
            {/* integration type */}
            {/* service type */}
            <div>
              <InputGroup className="mb-3">
                <InputGroup.Text
                  style={{ fontWeight: "bold" }}
                  id="basic-addon22"
                >
                  {`Service Type ${
                    copyServiceType !== ""
                      ? `(${copyServiceType === "portal" ? "Portal" : copyServiceType === "api" ? "API" : copyServiceType})`
                      : "(NA)"
                  }`}
                </InputGroup.Text>
                <Form.Select
                  aria-label="Service Type"
                  value={serviceType}
                  onChange={(e) => {
                    setServiceType(e.target.value);
                  }}
                >
                  <option value="" disabled>
                    {"Select Option"}
                  </option>
                  <option value={"API"}>API</option>
                  <option value={"Portal"}>Portal</option>
                </Form.Select>
              </InputGroup>
            </div>
            {/* service type */}
            <InputGroup className="mb-3">
              <InputGroup.Text id="inputGroup-sizing-default">
                <b>{"subscriptionStatus"}</b>
              </InputGroup.Text>

              <Form.Select
                aria-label="Default select example"
                onChange={(e) => setSubscriptionStatus(e.target.value)}
              >
                <option value="live" selected={subscriptionStatus === "live"}>
                  {"LIVE"}
                </option>
                <option
                  value="on hold"
                  selected={subscriptionStatus === "on hold"}
                >
                  {"HOLD"}
                </option>
                <option
                  value="inactive"
                  selected={subscriptionStatus === "inactive"}
                >
                  {"INACTIVE"}
                </option>
              </Form.Select>

              {/* <Form.Control
                                type="text"
                                defaultValue={subscriptionStatus}
                                onChange={(e) => setSubscriptionStatus(e.target.value)}
                                placeholder="subscriptionStatus"
                            /> */}
            </InputGroup>
            {/* number of tickets */}
            <InputGroup className="mb-3">
              <InputGroup.Text id="inputGroup-sizing-default">
                <b>{"Number of Tickets"}</b>
              </InputGroup.Text>
              <Form.Control
                type="number"
                min={0}
                value={numberOfTickets}
                onChange={(e) => setNumberOfTickets(e.target.value)}
                placeholder="Number of Tickets"
              />
            </InputGroup>
            {/* number of tickets */}
            
            {/* plan type */}
            <InputGroup className="mb-3">
              <InputGroup.Text id="inputGroup-sizing-default">
                <b>{"Plan Type"}</b>
              </InputGroup.Text>
              <Form.Select
                value={planType}
                onChange={(e) => setPlanType(e.target.value)}
                aria-label="Plan Type"
              >
                <option value="" disabled>
                  {"Select Plan Type"}
                </option>
                <option value="Copay Plan">Copay Plan</option>
                <option value="Starter Plan">Starter Plan</option>
                <option value="Pro Plan">Pro Plan</option>
                <option value="Growth Plan">Growth Plan</option>
                <option value="Enterprise Plan">Enterprise Plan</option>
              </Form.Select>
            </InputGroup>
            {/* plan type */}
            
            {/* client type */}
            <InputGroup className="mb-3">
              <InputGroup.Text id="inputGroup-sizing-default">
                <b>{"Client Type"}</b>
              </InputGroup.Text>
              <Form.Select
                value={clientType}
                onChange={(e) => setClientType(e.target.value)}
                aria-label="Client Type"
              >
                <option value="" disabled>
                  {"Select Client Type"}
                </option>
                <option value="LIS">LIS</option>
                <option value="LAB">LAB</option>
              </Form.Select>
            </InputGroup>
            {/* client type */}
            
            <Button variant="primary btn-sm" type="submit">
              Save Changes
            </Button>
            <Button
              onClick={submitSubscriptionData}
              className="mx-3"
              variant="success btn-sm"
              disabled={correctJsonFormat === ""}
            >
              Update Subscription Data
            </Button>
          </Form>
        </>
      );
    }
  };

  // react alert template options
  const options = {
    timeout: 5000,
    position: "bottom left",
  };

  return (
    <>
      <Provider template={AlertTemplate} {...options}>
        {loadingClientLookup ? (
          <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 120 }}>
            <Spinner animation="border" />
          </div>
        ) : fetchOrgStatus ? (
          returnFormJsx()
        ) : (
          userIdSelectionJSX()
        )}
      </Provider>
    </>
  );
};

export default Subscription;
